import "../../index28.css";
import { jsx as t } from "react/jsx-runtime";
import { _ } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
const i = "_heading_16glq_1", r = "_level-one_16glq_9", a = "_level-two_16glq_17", c = "_level-three_16glq_25", g = "_level-four_16glq_33", h = "_level-five_16glq_37", m = "_level-six_16glq_41", e = {
  heading: i,
  levelOne: r,
  levelTwo: a,
  levelThree: c,
  levelFour: g,
  levelFive: h,
  levelSix: m
}, u = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
};
function x(o) {
  const {
    className: n,
    level: l = 3,
    children: v
  } = o, s = `h${l}`;
  return v ? /* @__PURE__ */ t(
    s,
    {
      className: _(
        e.heading,
        u[l],
        n
      ),
      children: v
    }
  ) : null;
}
export {
  x as default
};
